<!--
 * @Author: Haotao
 * @Date: 2022-10-11 16:05:43-23 16:06:43
 * @LastEditors: Haotao
-->
<template>
  <div class='protocol'>
    <mt-header fixed title="协议预览">
      <router-link to slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)"></mt-button>
      </router-link>
    </mt-header>
    <div class="img-wrap">
      <ImagePreview :imgUrl="'https://oss.zhongxincloud.net/company/contract/tau_1740452767646blank.png'" alt="protocol" />
      <ImagePreview :imgUrl="'https://oss.zhongxincloud.net/company/contract/tau_1740452331824xy1.png'" alt="protocol" />
      <ImagePreview :imgUrl="'https://oss.zhongxincloud.net/company/contract/tau_1740452360341xy2.png'" alt="protocol" />
      <ImagePreview :imgUrl="'https://oss.zhongxincloud.net/company/contract/tau_1740452381810xy3.png'" alt="protocol" />
    </div>
    <div class='footer-bt'>
<!--      <mt-button type='danger' size='large' @click.native='handleNext'>去签名</mt-button>-->
    </div>
  </div>
</template>

<script>
import ImagePreview from '@components/image-preview';
export default {
  data() {
    return {}
  },
  components: {
    ImagePreview
  },
  mounted() {},
  methods: {
    handleNext() {
      // this.$router.replace('/individual-business/sign');
    }
  }
}
</script>

<style lang='less' scoped>
.img-wrap {
  width: 100%;
  height: 100%;
  margin-bottom: 24vw;
  > img {
    width: 100%;
    height: 100%;
  }
}
</style>
